import { render } from "./AssociateToUserButton.vue?vue&type=template&id=0c59669d&scoped=true"
import script from "./AssociateToUserButton.vue?vue&type=script&lang=js"
export * from "./AssociateToUserButton.vue?vue&type=script&lang=js"

import "./AssociateToUserButton.vue?vue&type=style&index=0&id=0c59669d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c59669d"]])

export default __exports__